import { combineReducers } from 'redux';

import addSupplementToInquiry from './addSupplementToInquiry/slice';
import createInquiry from './createInquiry/slice';
import createNewSupplement from './createNewSupplement/slice';
import deleteInquiryDraft from './deleteInquiryDraft/slice';
import inquiryDetails from './inquiryDetails/slice';
import removeMedicationFromInquiryDraft from './removeMedicationFromInquiryDraft/slice';
import removeSupplementFromInquiryDraft from './removeSupplementFromInquiryDraft/slice';
import submitInquiry from './submitInquiry/slice';
import supplementDetails from './supplementDetails/slice';
import supplementSearch from './supplementSearch/slice';
import userEnteredSupplementDetails from './userEnteredSupplementDetails/slice';

const inquiryDraftReducer = combineReducers({
  addSupplementToInquiry,
  createInquiry,
  createNewSupplement,
  deleteInquiryDraft,
  inquiryDetails,
  removeSupplementFromInquiryDraft,
  submitInquiry,
  supplementDetails,
  supplementSearch,
  userEnteredSupplementDetails,
  removeMedicationFromInquiryDraft,
});

export default inquiryDraftReducer;
